import { render, staticRenderFns } from "./multi-tenant-status.vue?vue&type=template&id=66a095f9&scoped=true&"
import script from "./multi-tenant-status.vue?vue&type=script&lang=js&"
export * from "./multi-tenant-status.vue?vue&type=script&lang=js&"
import style0 from "./multi-tenant-status.vue?vue&type=style&index=0&id=66a095f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a095f9",
  null
  
)

export default component.exports